import React from 'react'
import { Route, Redirect, RouteProps } from 'react-router-dom'
import { LOCAL_STORAGE_RIDER_PORTAL_USER_LOGGED_IN_KEY } from 'src/utils/auth'

interface ProtectedRouteProps extends RouteProps {
  component: React.ComponentType<any>
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ component: Component, ...rest }) => {
  const isAuthenticated = Boolean(localStorage.getItem(LOCAL_STORAGE_RIDER_PORTAL_USER_LOGGED_IN_KEY))

  return (
    <Route
      {...rest}
      render={props =>
        isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{ pathname: '/rider-portal', state: { from: props.location } }} //  Update the pathname to path assigned to sign in when other pages are implemented
          />
        )
      }
    />
  )
}

export default ProtectedRoute



// WEBPACK FOOTER //
// ./src/components/riders/rider-portal/ProtectedRoute.tsx